const StringUtils = {
    clearHTML: (message) => {
        let parser = new DOMParser();
        let dom = parser.parseFromString("<!doctype html><body>" + message, "text/html");
        return dom.body.textContent;
    },
    isDeepEqual: (a, b) => {
        return JSON.stringify(a) === JSON.stringify(b);
    },
    hashCodeStr: (string) => {
        var hash = 0;
        for (var i = 0; i < string.length; i++) {
            var code = string.charCodeAt(i);
            hash = (hash << 5) - hash + code;
            hash = hash & hash; // Convert to 32bit integer
        }
        return hash;
    },
    hashCodeObj: (obj) => {
        return StringUtils.hashCodeStr(JSON.stringify(obj));
    },
    stringToColor: (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
        let color = "#";
        for (let i = 0; i < 3; i++) {
            const value = (hash >> (i * 8)) & 0xff;
            color += ("00" + value.toString(16)).substr(-2);
        }
        return color;
    },
};

export default StringUtils;
